import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'

import Land from '@/module-land/index'


Vue.use(Router)

// 注册路由
const router = new Router({
  routes: [
    {
      path: '/', // 登陆
      name: 'land',
      component: Land
    }
  ]
})

// 路由权限控制
router.beforeEach((to, from, next) => {
  // if (to.path !== '/') {
  //   if (store.state.mineStore.isLogin === false) {
  //     next({ path: '/' })
  //   } else {
  //     next()
  //   }
  // } else {
  //   next()
  // }

  next()
  
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0) // 刷新视图，到顶部
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js